import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.function.name.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, sync } from 'vuex-pathify';
import { notify } from "../../functions/notifications";
import moment from 'moment';
import { FIB } from "../../config/constants";
var POST_NAVIGATION_DELAY = FIB.POST_NAVIGATION_DELAY;
export default {
  name: 'Staff',
  components: {
    FibConfirm: require("./ConfirmSurvey").default,
    FibManager: require("./Manager").default,
    FibStaffMember: require("./Member").default,
    FibPrivacyPolicy: require("../modals/PrivacyPolicy").default,
    FibSettings: require("../settings/Settings").default
  },
  data: function data() {
    return {
      manager: false,
      member: false,
      privacyPolicy: false,
      settings: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, get('config', ['branchId', 'deviceId', 'teamPinsEnabled', 'lastUpdated', 'menuItemsLastUpdated', 'branchDetails'])), get('manageTeam', ['getMemberFromId'])), {}, {
    enableStaffPinCodes: get('config/config@branch.enableStaffPinCodes'),
    branchName: get('config/config@branch.name'),
    loggedInMember: sync('settings/loggedInMember'),
    showSettingsSection: sync('settings/showSettingsSection'),
    response: sync('responses/response'),
    selectedTemplate: sync('settings/selectedTemplate'),
    surveyInProgress: sync('surveys/surveyInProgress'),
    completedSurveys: get('responses/responsesTemp'),
    responsesLastUpdated: get('responses/lastUpdated'),
    currentSurvey: get('surveys/currentSurvey'),
    teamMember: function teamMember() {
      return this.getMemberFromId(this.loggedInMember);
    }
  }),
  mounted: function mounted() {
    this.$store.commit('responses/resetCurrent');
    this.$store.commit('checkIn/resetState');
    this.surveyInProgress = null;
    this.updateFlow();
    this.setSnackbars();
  },
  methods: {
    done: function done(step) {
      this[step.name] = false;
      this.showSettingsSection = false;
      this.updateFlow();

      if (step.name === 'manager' && step.result) {
        this.settings = true;
      }

      if (step.name === 'member') {
        this.setSnackbars();
      } // if staff member is changed then need to set the loading state to false when done


      this.$store.commit('app/SET_PAGE_LOADING', false);
    },
    logout: function logout() {
      this.loggedInMember = null;
      this.settings = false;
      this.updateFlow();
    },
    startSurvey: function startSurvey() {
      var _this = this;

      this.$store.commit('app/SET_PAGE_LOADING', true);
      setTimeout(function () {
        _this.response = {
          answers: [],
          branchId: _this.branchId,
          completed: false,
          surveyId: _this.selectedTemplate,
          userId: null
        };
        _this.surveyInProgress = _this.selectedTemplate;

        if (_this.branchDetails.appEposTransactionRetrievalMethod === null) {
          // Inherit from survey
          _this.handleEposMethod(_this.currentSurvey.appEposTransactionRetrievalMethod);
        } else {
          // Branch level
          _this.handleEposMethod(_this.branchDetails.appEposTransactionRetrievalMethod);
        }
      }, POST_NAVIGATION_DELAY);
    },
    handleEposMethod: function handleEposMethod(eposRetrievalMethod) {
      switch (eposRetrievalMethod) {
        // Receipt PIN
        case 2:
          this.$router.push('/check_in/team_member_receipt_pin_entry');
          break;
        // Table number

        case 3:
          this.$router.push('/check_in/team_member_table_number_entry');
          break;
        // No EPOS

        default:
          this.$router.push('/check_in/get_started');
          break;
      }
    },
    updateFlow: function updateFlow() {
      if (this.surveyInProgress) {
        this.$router.push('/questions');
      } else if (!this.loggedInMember && this.teamPinsEnabled && !this.showSettingsSection) {
        this.member = true;
      } else if (this.showSettingsSection) {
        this.manager = true;
      }

      if (this.loggedInMember && !this.teamPinsEnabled) {
        this.logout();
      }
    },
    getTimeSince: function getTimeSince(date, unit) {
      return moment().diff(moment(this.$dateTime(date, 'YYYY-MM-DD HH:mm')), unit);
    },
    setSnackbars: function setSnackbars() {
      if (!this.loggedInMember || !this.teamMember.hasSettingsAccess) {
        return;
      }

      var daysSinceConfigUpdate = this.getTimeSince(this.lastUpdated, 'days');
      var daysSinceSurveyUpload = this.getTimeSince(this.responsesLastUpdated, 'days');
      var daysSinceMenuItemUpdate = this.getTimeSince(this.menuItemsLastUpdated, 'days'); // Display if config hasn't been updated for at least a day

      if (daysSinceConfigUpdate >= 1) {
        notify(this.$tc('appInfo.sinceConfigUpdate', daysSinceConfigUpdate === 1 ? 1 : 2, {
          days: daysSinceConfigUpdate
        }), null, 'negative', 'secondary');
      } // Display if there are completed surveys and they haven't been uploaded for at least a day


      if (this.completedSurveys.length > 0 && daysSinceSurveyUpload >= 1) {
        notify(this.$tc(daysSinceSurveyUpload === 1 ? 'appInfo.sinceSurveyUploadYesterday' : 'appInfo.sinceSurveyUpload', this.completedSurveys.length === 1 ? 1 : 2, {
          days: daysSinceSurveyUpload
        }), null, 'negative', 'secondary');
      } // Display if menu items haven't been updated for at least 7 days


      if (daysSinceMenuItemUpdate >= 7) {
        notify(this.$tc('appInfo.sinceMenuItemUpdate', daysSinceMenuItemUpdate === 7 ? 1 : 2, {
          days: daysSinceMenuItemUpdate
        }), null, 'negative', 'secondary');
      }
    }
  }
};